const LayoutTabsContent = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex h-full w-full flex-col rounded-[16px]  bg-white">
      <div className="flex h-[478px] w-full flex-col ">{children}</div>
    </div>
  );
};

export default LayoutTabsContent;
